import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"
import { Badge } from "@minuthq/meatball-ui-react"

import { ParadiseOrganizationTags } from "src/components/Paradise/ParadiseOrganizations/ParadiseOrganizationDetails/ParadiseOrganizationOverview/ParadiseOrganizationTags/ParadiseOrganizationTags"
import { ParadiseOverviewExpandable } from "src/components/Paradise/ParadiseOverviewExpandable"
import { ParadiseSettingStatic } from "src/components/Paradise/ParadiseSettings/ParadiseSettingStatic"
import { CopyWrapper } from "src/components/Paradise/sharedStyles"
import { IOrganization } from "src/data/organizations/types/organizationTypes"
import { useGetUser } from "src/data/user/hooks/useGetUser"
import { isSuperAdmin } from "src/data/user/logic/accessLogic"
import { Routes } from "src/router/routes"
import { CopyText } from "src/ui/CopyText/CopyText"
import { InternalLink } from "src/ui/Link/InternalLink"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseOrganizationOverview({
  organization,
}: {
  organization: IOrganization
}) {
  const loggedInUser = useGetUser()

  return (
    <ParadiseOverviewExpandable rawJson={organization}>
      <ParadiseSettingStatic
        title="Organization id"
        value={
          <CopyWrapper>
            <Text variant="bodyS">{organization.id}</Text>
            <CopyText
              value={organization.id}
              copiedText="Copied organization id"
            />
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Owner id"
        value={
          organization.owner_id ? (
            <CopyWrapper>
              <InternalLink
                to={Routes.ParadiseUser.location(organization.owner_id)}
              >
                {organization.owner_id}
              </InternalLink>
              <CopyText
                value={organization.owner_id}
                copiedText="Copied owner id"
              />
            </CopyWrapper>
          ) : (
            <Text variant="bodyS">-</Text>
          )
        }
      />

      <ParadiseSettingStatic
        title="Subscription"
        value={
          organization.current_plan ? (
            <SubscriptionWrapper>
              <div>{organization.current_plan}</div>
              <SubscriptionBadgeWrapper>
                <Badge color="good" size="small">
                  {organization.current_subscription_status}
                </Badge>

                {organization.billing_model === "contract" && (
                  <Badge color="info" size="small">
                    contract
                  </Badge>
                )}
              </SubscriptionBadgeWrapper>
            </SubscriptionWrapper>
          ) : (
            "-"
          )
        }
      />

      <ParadiseSettingStatic
        title="Created at"
        value={
          organization.created_at
            ? formatUtcDate({ date: organization.created_at })
            : "-"
        }
      />

      <ParadiseOrganizationTags
        currentTags={organization.tags}
        orgId={organization.id}
        disabled={!isSuperAdmin(loggedInUser.roles)}
      />
    </ParadiseOverviewExpandable>
  )
}

const SubscriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const SubscriptionBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.S};
`
